/* ============================================================
   SALIHA JOURNAL — scroll animations, parallax, progress, TOC
   Namespace: SJ
   Vanilla JS, zero dipendenze
   ============================================================ */

(function () {
  'use strict';

  var SJ = {};

  /* ─── UTILITIES ──────────────────────────────────────────────────────── */

  /**
   * Genera uno slug da una stringa di testo
   */
  function toSlug(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[àáâä]/g, 'a')
      .replace(/[èéêë]/g, 'e')
      .replace(/[ìíîï]/g, 'i')
      .replace(/[òóôö]/g, 'o')
      .replace(/[ùúûü]/g, 'u')
      .replace(/[ç]/g, 'c')
      .replace(/[ñ]/g, 'n')
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/[\s]+/g, '-')
      .replace(/-+/g, '-');
  }

  /* ─── 1. READING PROGRESS BAR ────────────────────────────────────────── */

  SJ.initProgressBar = function () {
    // Solo su .sj-article-page
    if (!document.querySelector('.sj-article-page')) return;

    var bar = document.createElement('div');
    bar.id = 'sj-progress-bar';
    var fill = document.createElement('div');
    fill.id = 'sj-progress-fill';
    bar.appendChild(fill);
    document.body.insertBefore(bar, document.body.firstChild);

    function updateProgress() {
      var docH = document.documentElement.scrollHeight;
      var windowH = window.innerHeight;
      var scrollable = docH - windowH;
      var pct = scrollable > 0 ? (window.scrollY / scrollable) * 100 : 0;
      fill.style.width = Math.min(Math.max(pct, 0), 100) + '%';
    }

    window.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();
  };

  /* ─── 2. SCROLL REVEAL — IntersectionObserver ────────────────────────── */

  SJ.initScrollReveal = function () {
    var targets = document.querySelectorAll('[data-reveal]');
    if (!targets.length) return;

    // Rispetta prefers-reduced-motion
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      targets.forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target); // una sola volta
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -60px 0px'
      }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  };

  /* ─── 3. PARALLAX HERO ───────────────────────────────────────────────── */

  SJ.initParallax = function () {
    var bgEls  = document.querySelectorAll('.sj-parallax-bg');
    var imgEls = document.querySelectorAll('.sj-parallax-img');
    if (!bgEls.length && !imgEls.length) return;

    // Skip su dispositivi lenti / retina alta (risparmio batteria)
    if (window.devicePixelRatio > 2) return;

    // Skip su mobile (sotto 768px) per performance
    if (window.innerWidth < 768) return;

    var ticking = false;

    function applyParallax() {
      var scrollY = window.scrollY;

      bgEls.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        // Parallax relativo alla posizione dell'elemento
        var offset = (rect.top + scrollY) * 0.35 - scrollY * 0.35;
        el.style.transform = 'translateY(' + (scrollY * 0.35) + 'px)';
      });

      imgEls.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var elCenter = rect.top + rect.height / 2;
        var viewCenter = window.innerHeight / 2;
        var delta = (elCenter - viewCenter) * 0.2;
        el.style.transform = 'translateY(' + delta + 'px)';
      });

      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(applyParallax);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    applyParallax(); // calcolo iniziale
  };

  /* ─── 4. READING TIME ────────────────────────────────────────────────── */

  SJ.initReadingTime = function () {
    var body = document.querySelector('.sj-article-body');
    var targets = document.querySelectorAll('[data-reading-time]');
    if (!body || !targets.length) return;

    var text = body.innerText || body.textContent || '';
    var words = text.trim().split(/\s+/).filter(function (w) { return w.length > 0; });
    var wordCount = words.length;
    var minutes = Math.max(1, Math.ceil(wordCount / 200));

    targets.forEach(function (el) {
      el.textContent = minutes;
    });
  };

  /* ─── 5. TOC BUILDER — solo desktop (>1024px) ────────────────────────── */

  SJ.initTOC = function () {
    // Solo desktop
    if (window.innerWidth < 1024) return;

    var body = document.querySelector('.sj-article-body');
    if (!body) return;

    var headings = body.querySelectorAll('h2, h3');
    if (headings.length < 3) return; // TOC solo se almeno 3 heading

    // Assegna id agli heading se mancano
    var seen = {};
    headings.forEach(function (h) {
      if (!h.id) {
        var base = toSlug(h.textContent);
        var slug = base;
        var counter = 1;
        while (seen[slug]) {
          slug = base + '-' + counter;
          counter++;
        }
        seen[slug] = true;
        h.id = slug;
      } else {
        seen[h.id] = true;
      }
    });

    // Costruisce il sidebar
    var sidebar = document.createElement('nav');
    sidebar.className = 'sj-toc-sidebar';
    sidebar.setAttribute('aria-label', 'Indice dell\'articolo');

    var title = document.createElement('p');
    title.className = 'sj-toc-title';
    title.textContent = 'In questo articolo';
    sidebar.appendChild(title);

    var list = document.createElement('ul');
    list.className = 'sj-toc-list';

    headings.forEach(function (h) {
      var li = document.createElement('li');
      li.className = h.tagName === 'H3' ? 'sj-toc-h3' : 'sj-toc-h2';

      var link = document.createElement('a');
      link.className = 'sj-toc-link';
      link.href = '#' + h.id;
      link.textContent = h.textContent.trim();

      link.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(h.id);
        if (target) {
          var top = target.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });

      li.appendChild(link);
      list.appendChild(li);
    });

    sidebar.appendChild(list);

    // Inserisce il TOC nell'articolo (prima del body o come fratello)
    var article = document.querySelector('.sj-article-page article, .sj-article-page .sj-article-wrap, .sj-article-page');
    if (article) {
      article.insertBefore(sidebar, body);
    } else {
      body.parentNode.insertBefore(sidebar, body);
    }

    // IntersectionObserver per aggiornare link attivo
    var links = list.querySelectorAll('.sj-toc-link');

    var headingObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var id = entry.target.id;
          var correspondingLink = list.querySelector('.sj-toc-link[href="#' + id + '"]');
          if (!correspondingLink) return;

          if (entry.isIntersecting) {
            links.forEach(function (l) { l.classList.remove('is-active'); });
            correspondingLink.classList.add('is-active');
          }
        });
      },
      {
        rootMargin: '-80px 0px -60% 0px',
        threshold: 0
      }
    );

    headings.forEach(function (h) {
      headingObserver.observe(h);
    });
  };

  /* ─── 6. STAGGER GRID ────────────────────────────────────────────────── */

  SJ.initStaggerGrid = function () {
    var grids = document.querySelectorAll('.sj-grid');
    if (!grids.length) return;

    grids.forEach(function (grid) {
      var children = grid.children;
      for (var i = 0; i < children.length; i++) {
        var child = children[i];
        var delay = Math.min(i + 1, 6); // max delay 6
        // Aggiunge data-reveal se non già presente
        if (!child.hasAttribute('data-reveal')) {
          child.setAttribute('data-reveal', 'true');
        }
        child.setAttribute('data-reveal-delay', String(delay));
      }
    });
  };

  /* ─── 7. INIT ────────────────────────────────────────────────────────── */

  function init() {
    var isArticlePage = !!document.querySelector('.sj-article-page');
    var isBlogPage    = !!document.querySelector('.sj-blog-page');

    if (!isArticlePage && !isBlogPage) return;

    // Stagger grids — prima del reveal observer
    SJ.initStaggerGrid();

    // Progress bar — solo articolo
    if (isArticlePage) {
      SJ.initProgressBar();
      SJ.initReadingTime();
      SJ.initTOC();
    }

    // Scroll reveal — su entrambe le pagine
    SJ.initScrollReveal();

    // Parallax — su entrambe
    SJ.initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // DOMContentLoaded già avvenuto
    init();
  }

  // Espone SJ globalmente per debug/estensioni
  window.SJ = SJ;

})();
